<template>
	<div class="ttshop_user">
		<Header></Header>
		<Userheader></Userheader>
		<div class="ttshop_user">
			<div class="ttshop_usercon w clearfloat">
				<Accountset></Accountset>
				<div class="ttshop_accountright">
					<div class="ttshop_accountaq">
						<div class="ttshop_accountaqup clearfloat">
							<div class="ttshop_accountaqimg">
								<img src="../../assets/images/goods_1.png" alt="">
							</div>
							<div class="ttshop_accountaqtext">
								<h5>1582****356</h5>
								<p><span>绑定手机：</span><strong>1852****369</strong></p>
								<p><span>邮箱绑定：</span><strong>未绑定</strong></p>
							</div>
						</div>
						<div class="ttshop_accountaqbut">
							<div class="ttshop_accouner clearfloat">
								<span>您的帐号安全评分：</span>
								<div class="ttshop_accounjd"><i style="width: 60%;"></i></div>
								<h5>60 <strong>分</strong></h5>
							</div>
							<ul>
								<li class="clearfloat">
									<p class="ttshop_warring"><i><img src="../../assets/images/ttshop_warring.png" alt=""></i>密码强度</p>
									<p class="ttshop_warrtext">密码强度为：<span>中</span></p>
									<strong>修改</strong>
								</li>
								<li class="clearfloat">
									<p class="ttshop_warring"><i><img src="../../assets/images/ttshop_warring.png" alt=""></i>绑定邮箱</p>
									<p class="ttshop_warrtext"><span>您未绑定邮箱</span></p>
									<strong>立即绑定</strong>
								</li>
								<li class="clearfloat">
									<p class="ttshop_warring"><i><img src="../../assets/images/ttshop_successmail.png" alt=""></i>绑定手机</p>
									<p class="ttshop_warrtext">您已绑定手机：<span>185****620</span></p>
									<strong>修改</strong>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import Userheader from "./components/user_index";
	import Accountset from "./components/accountset";
	export default {
		components: {
			Header,
			Userheader,
			Accountset,
			Foot,
		},
		data() {
			return {
				
			}
		},
		mounted() {

		},
		methods: {
			
		}
	};
</script>

<style lang="scss" scoped>
	.ttshop_accountright {
		float: right;
		width: 990px;
		min-height: 537px;
		background: #fff;
		.ttshop_accountaq{
			width: 100%;
			padding: 40px 55px;
			box-sizing: border-box;
			.ttshop_accountaqup{
				width: 100%;
				padding-bottom: 32px;
				box-sizing: border-box;
				border-bottom: 1px solid #EBEBEB;
				.ttshop_accountaqimg{
					float: left;
					width: 100px;
					height: 100px;
					border-radius: 50%;
					margin-right: 12px;
					img{
						display: block;
						width: 100%;
						height: 100%;
						object-fit: cover;
						border-radius: 50%;
					}
				}
				.ttshop_accountaqtext{
					float: left;
					h5{
						padding-top: 14px;
						box-sizing: border-box;
						font-size: 12px;
						color: #333;
						font-weight: 500;
						margin-bottom: 20px;
						line-height: 12px;
					}
					p{
						line-height: 24px;
						span{
							font-size: 12px;
							color: #333;
						}
						strong{
							font-size: 12px;
							color: #333;
						font-weight: 500;
						}
					}
				}
			}
			.ttshop_accountaqbut{
				width: 100%;
				padding-top: 40px;
				box-sizing: border-box;
				.ttshop_accouner{
					width: 100%;
					margin-bottom: 45px;
					span{
						float: left;
						font-size: 14px;
						color: #333;
						line-height: 14px;
						font-weight: 400;
						margin-right: 20px;
					}
					.ttshop_accounjd{
						float: left;
						width: 422px;
						height: 10px;
						overflow: hidden;
						border-radius: 25px;
						background: #EBEBEB;
						position: relative;
						margin-top: 3px;
						margin-right: 20px;
						i{
							display: block;
							position: absolute;
							top: 0;
							left: 0;
							height: 10px;
							border-radius: 25px;
							background: #FF0E25;
						}
					}
					h5{
						float: left;
						font-size: 30px;
						color: #FF0E25;
						font-weight: 500;
						margin-top: -19px;
						strong{
							font-size: 14px;
							color: #333;
							font-weight: 500;
							vertical-align: 1px;
						}
					}
				}
				ul{
					li{
						width: 100%;
						margin-bottom: 20px;
						&:last-child{
							margin-bottom: 0;
						}
						.ttshop_warring{
							float: left;
							font-size: 16px;
							color: #333;
							line-height: 32px;
							margin-right: 80px;
							i{
								display: inline-block;
								width: 32px;
								height: 32px;
								border-radius: 50%;
								margin-right: 12px;
								vertical-align: -9px;
								img{
									display: block;
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
							}
						}
						.ttshop_warrtext{
							float: left;
							font-size: 12px;
							color: #666;
							line-height: 32px;
							min-width: 150px;
							margin-right: 80px;
							span{
								font-size: 12px;
								color: #666;
							}
						}
						strong{
							float: left;
							font-weight: 500;
							font-size: 12px;
							color: #0E9CFF;
							line-height: 32px;
							cursor: pointer;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;
							opacity: 0.7;
							&:hover{
								opacity: 1;
							}
						}
					}
				}
			}
		}
	}
</style>
